import "./ParentHub.module.css";
import Header from "@/reusable_sections/Header";
import ParentCommandCenter from "./sections/ParentCommandCenter";
import SafetyFirst from "./sections/SafetyFirst";
import RegistrationForms from "./sections/RegistrationForms";
import Footer from "@/reusable_sections/Footer";
export default function ParentHubPage() {
  return <div>
      <Header />
      <ParentCommandCenter />
      <SafetyFirst />
      <RegistrationForms />
      <Footer />
    </div>;
}